<template>
  <div class="ConnaitreEquipe">
    <HeadPage title="L'Équipe"
              category="Nous connaitre"
              :img="null"
              :imgAlt="null"
    />
    <div class="ConnaitreEquipe-Content">
      <div class="ConnaitreEquipe-Content-Container">
        <Card :img="{
                color: 'nous-connaitre/collaborateurs/GV_Sourire.png',
                black: 'nous-connaitre/collaborateurs/GV_Serieux.png'
              }"
              :name="'Vigné'"
              :firstname="'Gilles'"
              :job="'Président Fondateur'"
              :text="'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla a massa sed turpis consequat sollicitudin et eu lectus.'"
              :socials="[
                        {
                            src: 'global/social/twitter.svg',
                            href: '#',
                            alt: 'Icon Twitter',
                            disabled: true
                        },
                        {
                            src: 'global/social/linkedin.svg',
                            href: 'https://www.linkedin.com/company/jobstreamsas/',
                            alt: 'Icon Linkedin',
                            disabled: false
                        },
                        {
                            src: 'global/social/facebook.svg',
                            href: '#',
                            alt: 'Icon Facebook',
                            disabled: true
                        }
                        ]"
        />
        <Card :img="{
                color: 'nous-connaitre/collaborateurs/PP_Sourire.png',
                black: 'nous-connaitre/collaborateurs/PP_Serieux.png'
              }"
              :name="'Philippe'"
              :firstname="'Pascal'"
              :job="'Directeur JobStream'"
              :text="'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla a massa sed turpis consequat sollicitudin et eu lectus.'"
              :socials="[
                        {
                            src: 'global/social/twitter.svg',
                            href: '#',
                            alt: 'Icon Twitter',
                            disabled: true
                        },
                        {
                            src: 'global/social/linkedin.svg',
                            href: 'https://www.linkedin.com/company/jobstreamsas/',
                            alt: 'Icon Linkedin',
                            disabled: false
                        },
                        {
                            src: 'global/social/facebook.svg',
                            href: '#',
                            alt: 'Icon Facebook',
                            disabled: true
                        }
                        ]"
        />
        <Card :img="{
                color: 'nous-connaitre/collaborateurs/JPB_Sourire.png',
                black: 'nous-connaitre/collaborateurs/JPB_Serieux.png'
              }"
              :name="'Bourdon'"
              :firstname="'Jean-Philippe'"
              :job="'Gérant du Groupe IP'"
              :text="'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla a massa sed turpis consequat sollicitudin et eu lectus.'"
              :socials="[
                        {
                            src: 'global/social/twitter.svg',
                            href: '#',
                            alt: 'Icon Twitter',
                            disabled: true
                        },
                        {
                            src: 'global/social/linkedin.svg',
                            href: 'https://www.linkedin.com/company/jobstreamsas/',
                            alt: 'Icon Linkedin',
                            disabled: false
                        },
                        {
                            src: 'global/social/facebook.svg',
                            href: '#',
                            alt: 'Icon Facebook',
                            disabled: true
                        }
                        ]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import Card from '../global/Card.vue'

export default {
  name: "ConnaitreEquipe",
  components: {
    HeadPage,
    Card
  }
}
</script>

<style scoped>
/* 
* Global 
*/
.ConnaitreEquipe-Content {
  text-align: center;
  margin: 70px 0;
}

.ConnaitreEquipe-Content-Container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
}
</style>